'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var appTypes = require('../../types/appTypes');
var TextParts = require('../common/TextParts');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');
var util = require('../../helper/util');
/**
 * 工具提示
 */
var ToolTip = React.createClass({

  createPath: function (graphics, direction, width, height) {
    var pathData = new util.Path.PathData();
    var offset = 0.5;
    var indicatorHeight = 10;
    var indicatorWidth = 14;
    var radius = 4;
    switch (direction) {
      case appTypes.ToolTipDirection.LEFT:
        pathData.moveTo(offset, height / 2)
          .lineTo(indicatorHeight - offset, height / 2 - indicatorWidth / 2)
          .lineTo(indicatorHeight - offset, radius)
          .curveTo(indicatorHeight - offset, offset, indicatorHeight + radius, offset)
          .lineTo(width - radius, offset)
          .curveTo(width - offset, offset, width - offset, radius)
          .lineTo(width - offset, height - radius)
          .curveTo(width - offset, height - offset, width - radius, height - offset)
          .lineTo(indicatorHeight + radius, height - offset)
          .curveTo(indicatorHeight - offset, height - offset, indicatorHeight - offset, height - radius)
          .lineTo(indicatorHeight - offset, height / 2 + indicatorWidth / 2)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.LEFT_TOP:
        pathData.moveTo(15, 0)
          .lineTo(15 + indicatorWidth, indicatorHeight - offset)
          .lineTo(width - radius, indicatorHeight - offset)
          .curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorWidth)
          .lineTo(width - offset, height - radius)
          .curveTo(width - offset, height - offset, width - radius, height - offset)
          .lineTo(radius, height - offset)
          .curveTo(offset, height - offset, offset, height - radius)
          .lineTo(offset, indicatorWidth - offset)
          .curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset)
          .lineTo(19, indicatorHeight - offset)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.TOP:
        pathData.moveTo(width / 2, 0)
          .lineTo(width / 2 + indicatorWidth / 2, indicatorHeight - offset)
          .lineTo(width - radius, indicatorHeight - offset)
          .curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorHeight + radius)
          .lineTo(width - offset, height - radius)
          .curveTo(width - offset, height - offset, width - radius, height - offset)
          .lineTo(radius, height - offset)
          .curveTo(offset, height - offset, offset, height - radius)
          .lineTo(offset, indicatorHeight + radius - offset)
          .curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset)
          .lineTo(width / 2 - indicatorWidth / 2, indicatorHeight - offset)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.RIGHT_TOP:
        pathData.moveTo(width - 15, 0)
          .lineTo(width - 19, indicatorHeight - offset)
          .lineTo(width - radius, indicatorHeight - offset)
          .curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorHeight + radius)
          .lineTo(width - offset, height - radius)
          .curveTo(width - offset, height - offset, width - radius, height - offset)
          .lineTo(radius, height - offset)
          .curveTo(offset, height - offset, offset, height - radius)
          .lineTo(offset, indicatorHeight + radius - offset)
          .curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset)
          .lineTo(width - 15 - indicatorWidth, indicatorHeight - offset)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.RIGHT:
        pathData.moveTo(width, height / 2)
          .lineTo(width - indicatorHeight + offset, height / 2 + indicatorWidth / 2)
          .lineTo(width - indicatorHeight + offset, height - radius)
          .curveTo(width - indicatorHeight + offset, height - offset, width - indicatorHeight - radius, height - offset)
          .lineTo(radius, height - offset)
          .curveTo(offset, height - offset, offset, height - radius)
          .lineTo(offset, radius)
          .curveTo(offset, offset, radius, offset)
          .lineTo(width - indicatorHeight - radius, offset)
          .curveTo(width - indicatorHeight + offset, offset, width - indicatorHeight + offset, radius)
          .lineTo(width - indicatorHeight + offset, height / 2 - indicatorWidth / 2)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.RIGHT_BOTTOM:
        pathData.moveTo(width - 15, height)
          .lineTo(width - 15 - indicatorWidth, height - indicatorHeight + offset)
          .lineTo(radius, height - indicatorHeight + offset)
          .curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius)
          .lineTo(offset, radius)
          .curveTo(offset, offset, radius, offset)
          .lineTo(width - radius, offset)
          .curveTo(width - offset, offset, width - offset, radius)
          .lineTo(width - offset, height - indicatorHeight - radius)
          .curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset)
          .lineTo(width - 19, height - indicatorHeight + offset)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.BOTTOM:
        pathData.moveTo(width / 2, height)
          .lineTo(width / 2 - indicatorWidth / 2, height - indicatorHeight + offset)
          .lineTo(radius, height - indicatorHeight + offset)
          .curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius)
          .lineTo(offset, radius)
          .curveTo(offset, offset, radius, offset)
          .lineTo(width - radius, offset)
          .curveTo(width - offset, offset, width - offset, radius)
          .lineTo(width - offset, height - indicatorHeight - radius)
          .curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset)
          .lineTo(width / 2 + indicatorWidth / 2, height - indicatorHeight + offset)
          .close()
          .stroke(graphics, true);
        break;
      case appTypes.ToolTipDirection.LEFT_BOTTOM:
        pathData.moveTo(15, height)
          .lineTo(19, height - indicatorHeight + offset)
          .lineTo(radius, height - indicatorHeight + offset)
          .curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius)
          .lineTo(offset, radius)
          .curveTo(offset, offset, radius, offset)
          .lineTo(width - radius, offset)
          .curveTo(width - offset, offset, width - offset, radius)
          .lineTo(width - offset, height - indicatorHeight - radius)
          .curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset)
          .lineTo(15 + indicatorWidth, height - indicatorHeight + offset)
          .close()
          .stroke(graphics, true);
        break;
    }
  },

  _doPaint: function () {

    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var dom = ReactDOM.findDOMNode(this);
    var graphics = canvas.getContext('2d');
    var clientWidth = dom.clientWidth;
    var clientHeight = dom.clientHeight;
    var direction = this.props.tipCornerDirection;
    var width = clientWidth;
    var height = clientHeight;
    canvas.width = width;
    canvas.height = height;

    this.requestID = window.requestAnimationFrame(function () {

      graphics.clearRect(0, 0, clientWidth, clientHeight);
      graphics.strokeStyle = '#000';
      graphics.lineWidth = 1;
      graphics.strokeWidth = 1;
      graphics.fillStyle = styleHelper.getBackgroundColor(this.props);
      this.createPath(graphics, direction, width, height)
    }.bind(this));
  },

  componentWillUnmount: function () {
    if (this.requestID) {
      cancelAnimationFrame(this.requestID);
    }
  },

  componentDidUpdate: function () {
    this._doPaint();
  },

  componentDidMount: function () {
    this._doPaint();
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize)
  },


  onResize: function (e) {
    this._doPaint();
    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
  },

  render: function () {

    this.radius = 4;
    this.angleHeight = 10;
    var padding = 7;//这个值是与桌面端一样的

    var direction = this.props.tipCornerDirection;
    var left = padding;
    var top = padding;
    var right = padding;
    var bottom = padding;
    var width = styleHelper.getWidth(this.props);
    var height = styleHelper.getHeight(this.props);


    if (direction === appTypes.ToolTipDirection.LEFT) {
      left = this.angleHeight + padding;
    } else if (direction === appTypes.ToolTipDirection.BOTTOM || direction === appTypes.ToolTipDirection.LEFT_BOTTOM || direction === appTypes.ToolTipDirection.RIGHT_BOTTOM) {
      bottom = this.angleHeight + padding;
    } else if (direction === appTypes.ToolTipDirection.TOP || direction === appTypes.ToolTipDirection.LEFT_TOP || direction === appTypes.ToolTipDirection.RIGHT_TOP) {
      top = this.angleHeight + padding;
    } else if (direction === appTypes.ToolTipDirection.RIGHT) {
      right = this.angleHeight + padding
    }
    var textStyle = {
      overflow: 'hidden',
      position: 'absolute',
      zIndex: 1
    };

    var props = _.extend({}, this.props);
    props.x = left;
    props.y = top;
    props.w = width - left - right;
    props.h = height - top - bottom;
    return (<div style={{width:'100%',height:'100%'}}>
      <canvas ref="canvas"
              style={{width:'100%',height:'100%'}}
      />
      <div style={{
        left:left,
        top:top,
        right : right,
        bottom:bottom,
        position:'absolute'
      }}>
        <TextParts ref="text" {...props} partStyle={textStyle}/>
      </div>

    </div>);
  }

});

module.exports = ToolTip;



// WEBPACK FOOTER //
// ./src/views/Components/ToolTip.jsx